import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
  {
    id: 1,
    icon: 'Shield',
    title: 'Sertifikasi ISO 9001:2015',
    description: 'Sistem Manajemen Mutu Internasional'
  },
  {
    id: 2,
    icon: 'Award',
    title: 'BPOM Certified',
    description: 'Terdaftar di Badan Pengawas Obat dan Makanan'
  },
  {
    id: 3,
    icon: 'CheckCircle2',
    title: 'Halal MUI',
    description: 'Sertifikasi Halal Majelis Ulama Indonesia'
  },
  {
    id: 4,
    icon: 'FileCheck',
    title: 'SNI Compliance',
    description: 'Memenuhi Standar Nasional Indonesia'
  }];


  const statistics = [
  { label: 'Perusahaan Terdaftar', value: '150+', icon: 'Building2' },
  { label: 'Analisis Selesai', value: '500+', icon: 'FileText' },
  { label: 'Tingkat Akurasi AI', value: '98.5%', icon: 'Brain' },
  { label: 'Pengguna Aktif', value: '1,200+', icon: 'Users' }];


  return (
    <div className="w-full max-w-md space-y-6">
      <div className="bg-card rounded-xl shadow-lg border border-border p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="ShieldCheck" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              Sertifikasi & Kepatuhan
            </h3>
            <p className="text-sm text-muted-foreground">
              Standar Industri Susu Indonesia
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {certifications?.map((cert) =>
          <div
            key={cert?.id}
            className="flex items-start gap-3 p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors">

              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={cert?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground mb-1">
                  {cert?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {cert?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-card rounded-xl shadow-lg border border-border p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="TrendingUp" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              Statistik Platform
            </h3>
            <p className="text-sm text-muted-foreground">
              Data per Februari 2026
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {statistics?.map((stat, index) =>
          <div
            key={index}
            className="p-4 rounded-lg bg-muted/50 text-center">

              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <Icon name={stat?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="text-2xl font-bold text-foreground mb-1 data-text">
                {stat?.value}
              </div>
              <div className="text-xs text-muted-foreground">
                {stat?.label}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-xl border border-border p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center flex-shrink-0">
            <Icon name="Sparkles" size={20} color="white" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">Teknologi DueDiligence Terdepan

            </h4>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Sistem analisis risiko berbasis kecerdasan buatan yang dirancang khusus untuk industri susu Indonesia, dengan kemampuan deteksi risiko tersembunyi dan simulasi skenario bisnis.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TrustSignals;